import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment';
import T from 'prop-types';
import { Box } from '@material-ui/core';
import { TaskShape, VIEWS, ACTION_TEXT } from 'workflow/constants/newInbox';
import newInboxActions from 'workflow/actions/newInbox';
import newInboxSelectors from 'workflow/selectors/newInbox';
import taskDetailActions from 'workflow/actions/taskDetail';
import StudyUsersTeamTable from '../../../pages/studyOverview/containers/StudyUsers/StudyUsersTeamTable';
import TaskSignature from 'workflow/components/NewInbox/Common/TaskSignature/TaskSignature';
import { getDashboardDetailsBinderStudiesTasks } from '../../../overview/actions/dashboard';
import { getDashboardDetailsBinderStudies } from '../../../overview/actions/dashboard';
import styles from './Tasks.scss';
import TaskWindowV4 from '../../components/NewInbox/Desktop/TaskWindowV4/TaskWindowV4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import DocumentDetailView from 'workflow/components/NewInbox/Common/DocumentDetailView/DocumentDetailView';

const DEFAULT_FILTER = { search: '', filter: {}, sort: { key: 'teamname', value: 'DESC' }, initial: true };

function MyTasks({ fetchTasksV4,
    tasks,
    tasksCount,
    status,
    userBinderStudiesNames,
    myTasksStudyBinderNames,
    getDashboardDetailsBinderStudiesTasks,
    tasksFetching,
    setTaskForDetailDisplay,
    taskWindowDetail,
    tasksForMultiSign,
    fetchTaskDetailByTask,
    tasksSigning,
    taskForSingleSign,
    submitSignTasks,
    originUrl,
    setTaskForSingleSign,
    view,
    changeView,
    setTaskWindowShowOnTaskLoad,
    shouldShowTaskWindowOnTaskLoad,
    isMobileView = false,
    switchTaskLoading
}) {
    const taskStyles = {
        centered: {
            display: 'flex',
            justifyContent: 'center',
        },
        myText: {
            fontFamily: 'Hind',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '42px',
            letterSpacing: '0em',
            textAlign: 'left',
            width: '367px',
            height: '42px',
        }
    };

    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [paginationdata, setPagination] = useState({ limit: 25, offset: 0, totalCount: 0 });
    const [extendedTaskWindow, setExtendedTaskWindow] = useState(false);
    const [isZeroState, setIsZeroState] = useState(false);
    const [initialLoading, setInititalLoading] = useState(true);

    const getMyTasksRecords = async () => {
        setInititalLoading(true);
        await getDashboardDetailsBinderStudiesTasks('name', 'ASC', '', 999999999, 0);
        await fetchTasksV4(status, 'DESC', '', '', isMobileView ? 999999999 : paginationdata.limit, isMobileView ? 0 : paginationdata.offset);
        setInititalLoading(false);
    };

    useEffect(() => {
        getMyTasksRecords();
        return async () => {
            await setTaskForDetailDisplay({});
        };
    }, []);

    useEffect(() => {
        if (!initialLoading) {
            const names = userBinderStudiesNames.length > 0
                ? [
                    ...myTasksStudyBinderNames,
                    ...lodash.map(userBinderStudiesNames, (userBinderAndStudy) => userBinderAndStudy.name)
                ]
                : myTasksStudyBinderNames;

            setColumns(buildMyTasksOpenColumns([...new Set(names)]));
        }
    }, [userBinderStudiesNames, myTasksStudyBinderNames, initialLoading, tasksForMultiSign]);

    useEffect(() => {
        if (!initialLoading) {
            if (!tasks.length && filterRecord.initial) {
                setIsZeroState(true);
            }
            else {
                setIsZeroState(false);
            }
            setRows(buildMyTasksOpenRows(tasks));
            setPagination({ ...paginationdata, totalCount: tasksCount });
        }
    }, [tasks, tasksCount, initialLoading, tasksForMultiSign]);

    useEffect(() => {
        if (!initialLoading && shouldShowTaskWindowOnTaskLoad && tasks.length) {
            let taskToShowOnTaskWindow = null;
            if (shouldShowTaskWindowOnTaskLoad == 'next')
                taskToShowOnTaskWindow = tasks.find((s) => s.id == taskWindowDetail.nextTask);
            if (shouldShowTaskWindowOnTaskLoad == 'previous')
                taskToShowOnTaskWindow = tasks.find((s) => s.id == taskWindowDetail.previousTask);

            if (taskToShowOnTaskWindow) {
                setTaskForDetailDisplay(taskToShowOnTaskWindow);
                setTaskWindowShowOnTaskLoad(false);
            }
        }
    }, [tasks, initialLoading]);

    useEffect(() => {
        if (!lodash.isEmpty(taskWindowDetail)) {
            fetchTaskDetailByTask(taskWindowDetail);
        }
    }, [taskWindowDetail]);

    const buildMyTasksOpenRows = (tasks) => {
        return lodash.map(tasks, (task) => {
            return {
                myTasksOpenTitle: lodash.get(task, ['title']),
                myTasksOpenType: lodash.get(task, ['type']),
                myTasksOpenAction: lodash.get(task, ['actionName']),
                myTasksOpenBinder: lodash.get(task, ['sentFrom']),
                myTasksOpenSentBy: lodash.get(task, ['sentBy']),
                myTasksOpenSentDate: formatDateString(lodash.get(task, ['sentDate'])),
                myTasksOpenDueDate: formatDateString(lodash.get(task, ['dueDate'])),
                myTasksCompletedDate: formatDateString(lodash.get(task, ['completedDate'])),
                taskDetailWindow: { ...task },
            };
        });
    };

    const buildMyTasksOpenColumns = (uniqueBinderNames) => {
        const myTasksOpenColumns = [
            {
                title: '',
                field: 'tasksForMultiSign',
                hidden: !tasksForMultiSign.length ? true : false,
                headerStyle: {
                    width: '2%',
                    minWidth: '2%',
                },
                cellStyle: {
                    width: '2%',
                    minWidth: '2%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                render: rowData => {
                    return (
                        tasksForMultiSign.find(s => s.id == rowData.taskDetailWindow.id) &&
                        <div style={{ color: '#2057AD' }}>
                            <FontAwesomeIcon icon={faCheck} />
                        </div >
                    );
                }
            },
            {
                title: 'Title',
                field: 'myTasksOpenTitle',
                searchPlaceholder: 'Tasks',
                hidden: false,
                headerStyle: {
                    width: '40%',
                },
                cellStyle: {
                    width: '40%',
                    color: 'var(--blue-500, #2057AD)',
                    maxWidth: 'none'
                },
                toolbarSearch: true,
                render: rowData => (
                    <Box className={styles.firstCol} onClick={() => setTaskForDetailDisplay(rowData.taskDetailWindow)} title={rowData.myTasksOpenTitle}>{rowData.myTasksOpenTitle}</Box>
                )
            },
            {
                title: 'Type',
                field: 'myTasksOpenType',
                searchPlaceholder: 'Type',
                hidden: !lodash.isEmpty(taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                    maxWidth: 0
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
            {
                title: 'Action',
                field: 'myTasksOpenAction',
                searchPlaceholder: 'Action',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                    maxWidth: 0
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                toolbarSearch: true,
                toolbarFilter: 'multiList',
                toolbarFilterData: [
                    {
                        label: 'Approve and Sign',
                        key: 'approve_and_sign'
                    },
                    {
                        label: 'Review and Sign',
                        key: 'review_and_sign'
                    },
                    {
                        label: 'Train and Sign',
                        key: 'train_and_sign'
                    },
                    {
                        label: 'Certify and Sign',
                        key: 'certify_and_sign'
                    },
                    {
                        label: 'Read and Acknowledge',
                        key: 'read_and_acknowledge'
                    }
                ]
            },
            {
                title: 'Binder',
                field: 'myTasksOpenBinder',
                searchPlaceholder: 'Binder',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                toolbarFilter: 'multiSearchList',
                toolbarFilterData: uniqueBinderNames
                    .filter(item => item !== null && item !== '')
                    .sort((a, b) => a.localeCompare(b))
                    .map(item => ({
                        label: item,
                        key: item
                    })),
            },
            {
                title: 'Sent By',
                field: 'myTasksOpenSentBy',
                searchPlaceholder: 'Sent By',
                hidden: !lodash.isEmpty(taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                toolbarSearch: true,
            },
            {
                title: 'Sent Date',
                field: 'myTasksOpenSentDate',
                searchPlaceholder: 'Sent Date',
                hidden: !lodash.isEmpty(taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                ...(status === 'pending'
                    ? {
                        toolbarSort: 'DESC',
                        toolbarDefaultSort: true,
                        toolbarSortByPostFix: [' (Newest First)', ' (Oldest First)'],
                    }
                    : {}),
            },
            {
                title: 'Due Date',
                field: 'myTasksOpenDueDate',
                searchPlaceholder: 'Due Date',
                hidden: !lodash.isEmpty(taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
            },
            {
                title: 'Completed Date',
                field: 'myTasksCompletedDate',
                searchPlaceholder: 'Completed Date',
                hidden: status === 'complete' ? !lodash.isEmpty(taskWindowDetail) ? true : false : true,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                ...(status === 'complete'
                    ? {
                        toolbarSort: 'DESC',
                        toolbarDefaultSort: true,
                        toolbarSortByPostFix: [' (Latest First)', ' (Earliest First)'],
                    }
                    : {}),
            },
        ];
        return myTasksOpenColumns;
    };

    const formatDateString = (dateString) => {
        if (dateString) {
            const date = moment.utc(dateString);
            const formattedDate = date.format('DD MMM YYYY');
            return formattedDate;
        } else {
            return null;
        }
    };

    const onFilterChange = async (filterRecords = filterRecord, pagination = paginationdata) => {
        if (filterRecords && !filterRecords.initial || isMobileView) {
            setFilterRecord(filterRecords);
            let filters = filterRecords ? JSON.stringify(filterRecords.filter) : '';
            let sortOrder = filterRecords ? filterRecords.sort.value.toString() : '';
            let queryText = filterRecords ? filterRecords.search : '';
            fetchTasksV4(status, sortOrder, queryText, filters, pagination.limit, pagination.offset);
        }
    };

    const backToMyTasksFromSignatureQueue = () => {
        setTaskForSingleSign({});
        if (lodash.isEmpty(taskWindowDetail)) {
            setExtendedTaskWindow(false);

            changeView(VIEWS.TASK_DETAIL);
        } else {
            changeView(VIEWS.TASK_DETAIL);
        }
    };

    const taskWindowNextPagination = async () => {
        await onFilterChange(filterRecord, { ...paginationdata, offset: paginationdata.offset + paginationdata.limit });
        await setTaskWindowShowOnTaskLoad('next');
        setPagination({ ...paginationdata, offset: paginationdata.offset + paginationdata.limit });
    };

    const taskWindowPreviousPagination = () => {
        setTaskWindowShowOnTaskLoad('previous');
        onFilterChange(filterRecord, { ...paginationdata, offset: paginationdata.offset - paginationdata.limit });
        setPagination({ ...paginationdata, offset: paginationdata.offset - paginationdata.limit });
    };

    const showZeroStateForFilter = (
        (Object.values(filterRecord.filter).length > 0 || Object.values(filterRecord.search).length > 0) &&
        tasks.length === 0
    );
    const getWidth = (taskWindowDetail, extendedTaskWindow) =>
        !lodash.isEmpty(taskWindowDetail) ? extendedTaskWindow ? '100%' : '600px' : '0px';

    const boxStyling = { width: getWidth(taskWindowDetail, extendedTaskWindow), display: 'flex', transition: 'all 0.3s ease', overflow: 'hidden', maxHeight: !tasksForMultiSign.length ? 'calc(100vh - 158.69px)' : 'calc(100vh - 237.69px)', position: 'relative' };

    const MobileMyTask = () => {
        return (
            <Box className={styles.mobileTask}>
                <span className={styles.taskTitle}>My Open Tasks</span>
                <Box className={[styles.taskCardContainer]}>
                    {rows.map((task) =>
                        <Box className={[styles.taskCard, tasksForMultiSign.find(s => s.id == task.taskDetailWindow.id) && styles.active]} key={task.taskDetailWindow.id} onClick={() => setTaskForDetailDisplay(task.taskDetailWindow)}>
                            <Box className={styles.taskName}>
                                <Box>
                                    {task.myTasksOpenTitle}
                                </Box>
                                {tasksForMultiSign.find(s => s.id == task.taskDetailWindow.id) &&
                                    <Box style={{ color: '#2057AD' }}>
                                        <FontAwesomeIcon icon={faCheck} className={styles.selectedIcon} />
                                    </Box >
                                }
                            </Box>
                            <Box>{task.myTasksOpenAction}</Box>
                            <Box>{task.myTasksOpenBinder}</Box>
                        </Box>
                    )}
                </Box>
            </Box>
        );
    };

    return (
        !initialLoading && tasks.length === 0 && !Object.values(filterRecord.filter).find(f => f.length) && isZeroState ? (
            <div style={taskStyles.centered}>
                <p style={taskStyles.myText}>
                    {status === 'pending' ? 'You do not have any open tasks.' : 'You do not have any completed tasks.'}
                </p>
            </div>
        ) : (
            <Fragment>
                <Box display={(view === VIEWS.DOCUMENT_DETAIL || view === VIEWS.TASK_SIGNATURE) ? 'none' : 'flex'} style={{ gap: extendedTaskWindow || isMobileView ? 0 : '20px' }} className={styles.taskContainer}>
                    <Box flex={1} style={{ width: extendedTaskWindow ? '0' : '100%', transition: 'all 0.3s ease', opacity: extendedTaskWindow ? 0 : 1, overflowY: 'auto' }}>
                        {isMobileView ?
                            <MobileMyTask /> :
                            <StudyUsersTeamTable
                                rows={rows}
                                columns={columns}
                                pagination={paginationdata}
                                setPagination={setPagination}
                                setFilterRecord={setFilterRecord}
                                filterRecord={filterRecord}
                                onFilterUpdate={onFilterChange}
                                onChangePagination={(pagination) => onFilterChange(filterRecord, pagination)}
                                footerLabel='tasks'
                                isLoadingTable={tasksFetching || initialLoading}
                                tableName="my tasks"
                                showFilterPills={true}
                                highLightRow={taskWindowDetail.id}
                                showZeroStateForFilter={showZeroStateForFilter}
                            />}
                    </Box>

                    {view !== VIEWS.DOCUMENT_DETAIL && !lodash.isEmpty(taskWindowDetail) && !isMobileView &&
                        <Box style={boxStyling}>
                            <TaskWindowV4
                                taskStatus={status}
                                extendedTaskWindow={extendedTaskWindow} setExtendTaskWindow={() => {
                                    setExtendedTaskWindow(!extendedTaskWindow);
                                }}
                                paginateToNextPage={taskWindowNextPagination}
                                paginateToPreviousPage={taskWindowPreviousPagination}
                                paginationdata={paginationdata}
                                paginationTotal={paginationdata.totalCount}
                                isLoading={tasksFetching}
                                switchTaskLoading={switchTaskLoading}
                            />
                        </Box>}

                    {view !== VIEWS.DOCUMENT_DETAIL && !lodash.isEmpty(taskWindowDetail) && isMobileView &&
                        <Box style={{ padding: '10px', width: '100%', display: 'flex', transition: 'all 0.3s ease', overflow: 'hidden', position: 'relative' }}>
                            <TaskWindowV4
                                taskStatus={status}
                                extendedTaskWindow={extendedTaskWindow} setExtendTaskWindow={() => {
                                    setExtendedTaskWindow(!extendedTaskWindow);
                                }}
                                paginateToNextPage={taskWindowNextPagination}
                                paginateToPreviousPage={taskWindowPreviousPagination}
                                paginationdata={paginationdata}
                                paginationTotal={paginationdata.totalCount}
                                isLoading={tasksFetching}
                                isMobileView={isMobileView}
                                switchTaskLoading={switchTaskLoading}
                            />
                        </Box>}



                </Box >
                {view === VIEWS.TASK_SIGNATURE &&
                    <Box style={{ display: view === VIEWS.TASK_SIGNATURE ? 'block' : 'none' }}>
                        <TaskSignature
                            tasksSigning={tasksSigning}
                            taskForSingleSign={taskForSingleSign}
                            tasksForMultiSign={tasksForMultiSign}
                            changeView={backToMyTasksFromSignatureQueue}
                            originUrl={originUrl}
                            actionText={ACTION_TEXT}
                            onSignTasksSubmit={submitSignTasks}
                            isNewV4={true}
                            callBackOnSuccess={onFilterChange}
                            isMobileView={isMobileView}
                        />
                    </Box>
                }
                {view === VIEWS.DOCUMENT_DETAIL &&
                    <Box style={{ display: view === VIEWS.DOCUMENT_DETAIL ? 'block' : 'none' }}>
                        <DocumentDetailView changeView={changeView} taskId={taskWindowDetail.id} isNewV4={true} />
                    </Box>
                }
            </Fragment>
        )
    );
}

MyTasks.propTypes = {
    fetchTaskDetailByTask: T.func,
    fetchTasksV4: T.func,
    tasks: T.arrayOf(T.shape(TaskShape)),
    taskWindowDetail: T.shape(TaskShape),
    tasksSigning: T.bool,
};

const mapStateToProps = state => ({
    tasks: newInboxSelectors.getTasks(state),
    tasksCount: newInboxSelectors.getTasksCount(state),
    myTasksStudyBinderNames: newInboxSelectors.getTasksStudyBinderNames(state),
    userBinderStudiesNames: lodash.get(state, 'dashboard.binderStudiesTasks', []),
    tasksFetching: lodash.get(state, 'tasksFetching', false),
    shouldShowTaskWindowOnTaskLoad: lodash.get(state, 'shouldShowTaskWindowOnTaskLoad', false),
    //taskWindowDetail: lodash.get(state, 'taskWindowDetail', false),
    taskWindowDetail: newInboxSelectors.getTaskForDetailDisplay(state),
    tasksSigning: newInboxSelectors.getTasksSigning(state),
    tasksForMultiSign: lodash.get(state, 'tasksForMultiSign', []),
    originUrl: newInboxSelectors.getOriginUrl(state),
    taskForSingleSign: newInboxSelectors.getTaskForSingleSign(state),
    view: newInboxSelectors.getView(state),
    switchTaskLoading: lodash.get(state, 'taskDetailFetching', false)
});

const mapDispatchToProps = {
    fetchTaskDetailByTask: taskDetailActions.fetchTaskDetail,
    fetchTasksV4: newInboxActions.fetchTasksV4,
    getDashboardDetailsBinderStudies,
    setTaskForDetailDisplay: newInboxActions.setTaskForDetailDisplay,
    toggleTaskForMultiSign: newInboxActions.toggleTaskForMultiSign,
    getDashboardDetailsBinderStudiesTasks,
    submitSignTasks: newInboxActions.submitSignTasks,
    setTaskForSingleSign: newInboxActions.setTaskForSingleSign,
    changeView: newInboxActions.changeView,
    setTaskWindowShowOnTaskLoad: newInboxActions.setTaskWindowShowOnTaskLoad
};

export { MyTasks as MyTasks };
export default connect(mapStateToProps, mapDispatchToProps)(MyTasks);
